export enum EventTypeId {
  CONFERENCE = 1,
  SPORT,
  PRIVATE_EVENT,
  CULTURE,
}

export interface EventType {
  id: number;
  name: string;
}
